// Fonts
import "~/assets/fonts/LADAPragmatica.woff2";
import "~/assets/fonts/Roboto.woff2";
import "~/assets/fonts/Robotobold.woff2";
import "~/assets/fonts/Robotoitalic.woff2";
import "~/assets/fonts/Robotolight.woff2";
import "~/assets/fonts/Robotomedium.woff2";
import "~/assets/fonts/Robotothin.woff2";

import React from "react";
import { createRoot } from "react-dom/client";

import VersionContextProvider from "~/versionControl/VersionContextProvider";
import { logBuildInfo } from "~/utils/buildInfo";

import { App } from "./App";

// Styles
import "normalize.css";
import "~/assets/css/default.css";
import "~/assets/less/common.less";
import "@pd/pd-ui-kit/styles.css";

// Вывод информации о билде в консоль
logBuildInfo();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);
root.render(
  <VersionContextProvider>
    <App />
  </VersionContextProvider>,
);
